import React, { useEffect, useRef, useState } from 'react'

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { loadLanguages, loadSetting, saveAbout} from '../utils/Network';
import { sortLanguages } from '../utils';
import Gallery from './Gallery';
export default function AboutContent() {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [image, setImage] = useState(null);
    const [file, setFile] = useState(null);
    const [title, setTitle] = useState(null);
    const [about, setAbout] = useState("");
    const [settings, setSettings] = useState([]);
    const [languages, setLanguages] = useState(null);
    const [activeLanguageId, setActiveLanguageId] = useState(null);
    const [names, setNames] = useState(null);
    const [gallery_item, setGalleryItem] = useState(false);
    const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);
    const [selected_image_name, setSelectedImageName] = useState(false);
    

    
    const [about_circle_image_1, setAboutCircleImage1] = useState(null);
    const [about_circle_image_2, setAboutCircleImage2] = useState(null);
    const [about_circle_image_3, setAboutCircleImage3] = useState(null);
    const [about_circle_image_4, setAboutCircleImage4] = useState(null);

    useEffect(() => {


        setLoading(true)
        loadLanguages().then(languages => {
            const sortedLanguages = sortLanguages(languages);
            //languages=languages.filter(x=> x.language !==16)
            setLanguages(sortedLanguages);
            setActiveLanguageId(
                sortedLanguages.find((lang) => lang.is_default)?.id || sortedLanguages[0]?.id || null
            );
        });

        loadSetting().then(setting => {

            setSettings(setting)
            setTitle(setting.about_title)
            setAbout(setting.about)
            setImage(setting.about_image)
            setNames(setting.names)

            setAboutCircleImage1(setting.about_circle_image_1)
            setAboutCircleImage2(setting.about_circle_image_2)
            setAboutCircleImage3(setting.about_circle_image_3)
            setAboutCircleImage4(setting.about_circle_image_4)

            setLoading(false)
        })
    }, []);

    const handleNamesOnChange = (e) => {
        //alert(e.target.value)
        var language_id = e.target.getAttribute("language_id")

        var name = null;
        if (names) {
            name = names.find(x => x.language === parseInt(language_id));
        }
        if (name) {
            var temp_names = [...names];
            temp_names.find(x => x.language === parseInt(language_id)).name = e.target.value;
            setNames(temp_names)
        }
        else {

            var new_name = { name: e.target.value, description: "", language: parseInt(language_id) }
            var temp_namesa = [];
            if (names)
                temp_namesa = [...names, new_name];
            else temp_namesa = [new_name]
            setNames(temp_namesa)
        }
    }

    const handleDescriptionChange = (language_id, data) => {
        //alert(data)

        var name = null;
        if (names) {
            name = names.find(x => x.language === parseInt(language_id));
        }
        if (name) {
            var temp_names = [...names];
            temp_names.find(x => x.language === parseInt(language_id)).description = data;
            setNames(temp_names)
        }
        else if (!settings.id) { //if (!settings.id)

            var new_name = { name: "", description: data, language: parseInt(language_id) }
            var temp_namesa = [];
            if (names)
                temp_namesa = [...names, new_name];
            else temp_namesa = [new_name]
            setNames(temp_namesa)
        }
    }

    const onChange = (e, language_id) => {
        var temp = settings

        var name = null;
        if (names) {
            name = names.find(x => x.language === parseInt(language_id));
        }

        var temp_names = [...names]

        switch (e.target.name) {
            case 'title':
                setTitle(e.target.value)
                temp.about_title = e.target.value
                setSettings(temp)
                break;
            case 'about_circle_title_1':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_circle_title_1 = e.target.value
                    setNames(temp_names)
                }

                break;
            case 'about_circle_title_2':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_circle_title_2 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_circle_title_3':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_circle_title_3 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_circle_title_4':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_circle_title_4 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_icons_title_1':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_icons_title_1 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_icons_title_2':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_icons_title_2 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_icons_title_3':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_icons_title_3 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_icons_title_4':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_icons_title_4 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_icons_description_1':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_icons_description_1 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_icons_description_2':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_icons_description_2 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_icons_description_3':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_icons_description_3 = e.target.value
                    setNames(temp_names)
                }
                break;
            case 'about_icons_description_4':
                if (name) {
                    temp_names.find(x => x.language === parseInt(language_id)).about_icons_description_4 = e.target.value
                    setNames(temp_names)
                }
                break;

            default:

                break;
        }
    }
    const handleDescriptionOnChange = (data) => {
        setAbout(data)

    }
    

    
    const SaveChanges = () => {

        setError(null)

        console.log(names)

        setLoading(true)
        saveAbout(settings, names, title, about, file).then(data => {
            console.log(data)
            if (data.id) {
                setImage(data.about_image)
                setAboutCircleImage1(data.about_circle_image_1)
                setAboutCircleImage2(data.about_circle_image_2)
                setAboutCircleImage3(data.about_circle_image_3)
                setAboutCircleImage4(data.about_circle_image_4)
            }
            setLoading(false)
        })
    }



    const setSelectedImageGallery = (gallery_item) => {
        setGalleryItem(gallery_item)
        console.log(gallery_item)

        var temp  = settings;

        switch (selected_image_name) {
            case 1:
                setAboutCircleImage1(gallery_item?.image)
                temp.about_circle_image_1=gallery_item?.image
                setSettings(temp)
                break;
            case 2:
                setAboutCircleImage2(gallery_item?.image)
                temp.about_circle_image_2 = gallery_item?.image
                setSettings(temp)
                break;
            case 3:
                setAboutCircleImage3(gallery_item?.image)
                temp.about_circle_image_3 = gallery_item?.image
                setSettings(temp)
                break;
            case 4:
                setAboutCircleImage4(gallery_item?.image)
                temp.about_circle_image_4 = gallery_item?.image
                setSettings(temp)
                break;
            case "about_image":
                setImage(gallery_item?.image)
                temp.about_image = gallery_item?.image
                setSettings(temp)
                break;
            default:
                break;
        }
        
    }

    const openGallery = (circle_image_number) => {

        setSelectedImageName(circle_image_number)
        setGalleryModalIsOpen(true)

    }

    const closeGallery = () => {
        setGalleryModalIsOpen(false)
    }

    return (
        <>
            <Gallery setSelectedGalleryItem={setSelectedImageGallery} isOpen={gallery_modal_is_open} key={gallery_modal_is_open} closeGallery={() => { closeGallery() }} />

            <div className="content-wrapper">
                <section className="content-header">
                    <h3 className="box-title mb-10"></h3>
                    <ol className="breadcrumb">
                        <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                        <li className="active">Settings </li>
                        <li className="active">About </li>
                    </ol>
                </section>



                <section className="content padding-top-sm-0">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="box">
                                <div className="box-header">
                                    About Settings
                                </div>
                                <div className="box-body padding-10">

                                    <div className="form-group">

                                        <div className="nav-tabs-custom cms-about-language-tabs">
                                            <div className="widget-tabs cms-page-tabs">
                                                {languages && languages.map((language) =>
                                                (
                                                    <button
                                                        key={language.id}
                                                        type="button"
                                                        className={`${language.name === 'کوردی' ? "kfont " : ""}widget-tab-btn${activeLanguageId === language.id ? " active" : ""}`}
                                                        onClick={() => setActiveLanguageId(language.id)}
                                                    >
                                                        {language.name}
                                                    </button>
                                                )

                                                )}
                                            </div>
                                            <div className="tab-content padding-10">
                                                {languages && languages.map((language, i) =>
                                                (
                                                    <div key={i} className={activeLanguageId === language.id ? "tab-pane active" : "tab-pane "} id={`tab${language.id}`}>

                                                        <div className="form-row">
                                                            <input type="text" name="name" className="form-control mb-10 mxw-200" language_id={language.id} value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).name : ""} onChange={handleNamesOnChange} placeholder={language.name} />
                                                        </div>

                                                        <div className="form-row">
                                                            <label className=""></label>
                                                            <div className="">
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).description ? names.find(x => x.language === language.id).description : "" : ""}
                                                                    onReady={editor => {
                                                                        // You can store the "editor" and use when it is needed.
                                                                    }}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        handleDescriptionChange(language.id, data)
                                                                    }}
                                                                />
                                                            </div>



                                                        </div>
                                                        <div className=" about__circleTitles">
                                                            <div className="row">
                                                                <div className="col-md-3 circles-container">
                                                                    <input type="text"
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_circle_title_1 : ""}
                                                                        name="about_circle_title_1" onChange={(e) => { onChange(e, language.id) }} className="form-control" placeholder="Circle Title" />

                                                                </div>
                                                                <div className="col-md-3 circles-container">
                                                                    <input type="text"
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_circle_title_2 : ""}
                                                                        name="about_circle_title_2" onChange={(e) => { onChange(e, language.id) }} className="form-control" placeholder="Circle Title" />

                                                                </div>
                                                                <div className="col-md-3 circles-container">
                                                                    <input type="text"
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_circle_title_3 : ""}
                                                                        name="about_circle_title_3" onChange={(e) => { onChange(e, language.id) }} className="form-control" placeholder="Circle Title" />

                                                                </div>
                                                                <div className="col-md-3 circles-container">
                                                                    <input type="text"
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_circle_title_4 : ""}
                                                                        name="about_circle_title_4" onChange={(e) => { onChange(e, language.id) }} className="form-control" placeholder="Circle Title" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-group">
                                                            <div className="row">
                                                                <div className="col-md-3 circles-container">
                                                                    <input type="text"
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_icons_title_1 : ""}
                                                                        name="about_icons_title_1" onChange={(e) => { onChange(e, language.id) }} className="form-control mb-8" placeholder="Title" />
                                                                    <textarea
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_icons_description_1 : ""}
                                                                    name="about_icons_description_1" onChange={(e) => { onChange(e, language.id) }} className="form-control" placeholder="Description" rows="5"></textarea>
                                                                </div>
                                                                <div className="col-md-3 circles-container">
                                                                    <input type="text" 
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_icons_title_2 : ""}
                                                                    name="about_icons_title_2" onChange={(e) => { onChange(e, language.id) }} className="form-control mb-8" placeholder="Title" />
                                                                    <textarea
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_icons_description_2 : ""}
                                                                    name="about_icons_description_2" onChange={(e) => { onChange(e, language.id) }} className="form-control" placeholder="Description" rows="5"></textarea>
                                                                </div>
                                                                <div className="col-md-3 circles-container">
                                                                    <input type="text" 
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_icons_title_3 : ""}
                                                                    name="about_icons_title_3" onChange={(e) => { onChange(e, language.id) }} className="form-control mb-8" placeholder="Title" />
                                                                    <textarea
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_icons_description_3 : ""}
                                                                    name="about_icons_description_3" onChange={(e) => { onChange(e, language.id) }} className="form-control" placeholder="Description" rows="5"></textarea>
                                                                </div>
                                                                <div className="col-md-3 circles-container">
                                                                    <input type="text"
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_icons_title_4 : ""}
                                                                    name="about_icons_title_4" onChange={(e) => { onChange(e, language.id) }} className="form-control mb-8" placeholder="Title" />
                                                                    <textarea 
                                                                        value={names && names.find(x => x.language === language.id) ? names.find(x => x.language === language.id).about_icons_description_4 : ""}
                                                                    name="about_icons_description_4" onChange={(e) => { onChange(e, language.id) }} className="form-control" placeholder="Description" rows="5"></textarea>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                )

                                                )}

                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group hide">
                                        <input type="text" value={title} name="title" onChange={onChange} className="form-control post-title max-w-300" placeholder="Title" />
                                    </div>

                                    <div className="form-group mb-30 hide">
                                        <CKEditor
                                            editor={ClassicEditor}
                                            data={about}
                                            onReady={editor => {
                                                // You can store the "editor" and use when it is needed.
                                            }}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                handleDescriptionOnChange(data)
                                            }}
                                        />
                                    </div>
                                
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-3 circles-container">
                                                <img src={about_circle_image_1 ? about_circle_image_1 : "images/default.png"} onClick={() => { openGallery(1) }} className="img-circle img-icons img-fluid" />

                                            </div>
                                            <div className="col-md-3 circles-container">
                                                <img src={about_circle_image_2 ? about_circle_image_2 : "images/default.png"} onClick={() => { openGallery(2) }} className="img-circle img-icons img-fluid" />

                                            </div>
                                            <div className="col-md-3 circles-container">
                                                <img src={about_circle_image_3 ? about_circle_image_3 : "images/default.png"} onClick={() => { openGallery(3) }} className="img-circle img-icons img-fluid" />

                                            </div>
                                            <div className="col-md-3 circles-container">
                                                <img src={about_circle_image_4 ? about_circle_image_4 : "images/default.png"} onClick={() => { openGallery(4) }} className="img-circle img-icons img-fluid" />
                                            </div>
                                        </div>
                                    </div>


                                </div>


                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="box">
                                <div className="box-header">
                                    Gallery
                                </div>
                                <div className="box-body padding-10">


                                    <div className="form-group">
                                        <img className="img upload-img mb-5" onClick={() => { openGallery('about_image')  }} src={image ? image : "images/default.png"} />
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <button className="btn btn-primary pull-right" onClick={SaveChanges}>Save Changes</button>
                                    <a href={`posts`} className="btn btn-default pull-left">Cancel</a>
                                </div>
                                {error &&
                                    <div className="alert alert-danger mt-5">
                                        {error}
                                    </div>
                                }
                                {loading &&
                                    <div className="alert alert-info  mt-5">
                                        Please Wait...
                                    </div>
                                }
                            </div>

                        </div>
                    </div>
                </section>

            </div>
        </>



    )
}
